var _excluded = ["property"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { AllhomesSearchListingCard } from './search-result-card';
import { ListingCardFragmentFragmentDoc } from './search-result.fragment.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = ListingCardFragmentFragmentDoc;
var graphQLToProps = _ref => {
  var _listing$firstImage, _listing$media, _listing$media2, _listing$media3, _address$division, _address$state, _agencies$, _agencies$2, _development$logo, _agencies$3, _agencies$3$images, _agencies$4, _agencies$0$agents, _features$bathrooms, _features$parking;
  var listing = _ref.listing,
    address = _ref.address,
    agencies = _ref.agencies,
    features = _ref.features,
    development = _ref.development;
  return {
    listing: {
      id: Number(listing.id),
      type: listing.type,
      url: listing.url,
      firstImage: (_listing$firstImage = listing.firstImage) === null || _listing$firstImage === void 0 ? void 0 : _listing$firstImage.imageSrc,
      priceLabel: listing.price,
      annotations: listing.annotations,
      numPhotos: (_listing$media = listing.media) === null || _listing$media === void 0 ? void 0 : _listing$media.photoCount,
      hasVideo: (_listing$media2 = listing.media) === null || _listing$media2 === void 0 ? void 0 : _listing$media2.hasVideo,
      has3dTour: (_listing$media3 = listing.media) === null || _listing$media3 === void 0 ? void 0 : _listing$media3.hasVirtualTour,
      events: listing.events
    },
    address: {
      street: address.line1,
      division: (_address$division = address.division) === null || _address$division === void 0 ? void 0 : _address$division.name,
      postcode: address.postcode,
      state: (_address$state = address.state) === null || _address$state === void 0 ? void 0 : _address$state.abbrev
    },
    agency: {
      name: development ? undefined : (_agencies$ = agencies[0]) === null || _agencies$ === void 0 ? void 0 : _agencies$.name,
      url: development ? undefined : (_agencies$2 = agencies[0]) === null || _agencies$2 === void 0 ? void 0 : _agencies$2.profileUrl,
      logo: (development === null || development === void 0 ? void 0 : (_development$logo = development.logo) === null || _development$logo === void 0 ? void 0 : _development$logo.image) || ((_agencies$3 = agencies[0]) === null || _agencies$3 === void 0 ? void 0 : (_agencies$3$images = _agencies$3.images) === null || _agencies$3$images === void 0 ? void 0 : _agencies$3$images.logo),
      logoBackground: development ? undefined : (_agencies$4 = agencies[0]) === null || _agencies$4 === void 0 ? void 0 : _agencies$4.logoBackgroundColour,
      agents: development && (agencies === null || agencies === void 0 ? void 0 : agencies.length) > 1 ? [] : (_agencies$0$agents = agencies[0].agents) === null || _agencies$0$agents === void 0 ? void 0 : _agencies$0$agents.map(agent => ({
        name: agent === null || agent === void 0 ? void 0 : agent.name,
        image: agent === null || agent === void 0 ? void 0 : agent.profilePhoto
      }))
    },
    property: {
      types: features.propertyType ? [features.propertyType] : [],
      beds: features.bedrooms || 0,
      baths: ((_features$bathrooms = features.bathrooms) === null || _features$bathrooms === void 0 ? void 0 : _features$bathrooms.total) || 0,
      cars: ((_features$parking = features.parking) === null || _features$parking === void 0 ? void 0 : _features$parking.total) || 0,
      size: features.buildingSize || 0,
      eer: features.eer || 0
    }
  };
};
var AllhomesSearchListingCardGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(AllhomesSearchListingCard, _extends({}, graphQLToProps(property), props));
};
AllhomesSearchListingCardGraphQL.fragment = fragment;
export default AllhomesSearchListingCardGraphQL;